function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSpaceRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 137213"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 137204"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121132",
    d: "m0 40.336 15.491-7.6v-7.867L0 20.751z",
    transform: "translate(7.25 -.653)",
    style: {
      fill: "#d7262e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121133",
    d: "m.272 55.641 22.5 6.75V49.056l-5.893-1.567z",
    transform: "translate(7.121 -13.371)",
    style: {
      fill: "#d7262e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121134",
    d: "m1.739 8.95 14.579 3.876V.618z",
    transform: "translate(6.423 8.924)",
    style: {
      fill: "#d7262e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121135",
    d: "M34.088 0v13.165l5.894 1.567 16.393-8.046z",
    transform: "translate(-8.965 9.218)",
    style: {
      fill: "#d7262e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121136",
    d: "M47.73 25.089v7.862l15.491 4.12V17.487z",
    transform: "translate(-15.453 .9)",
    style: {
      fill: "#d7262e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121137",
    d: "m34.089 36.913 4.769 1.268v-7.1l-4.769-1.268z",
    transform: "translate(-8.965 -4.963)",
    style: {
      fill: "#d7262e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 121138",
    d: "m47.73 64.064 14.781-8.446-14.781-3.931z",
    transform: "translate(-15.453 -15.368)",
    style: {
      fill: "#d7262e"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpaceRed);
export default __webpack_public_path__ + "static/media/icon_space_red.e456dd6e5cc425349277f78e448e1514.svg";
export { ForwardRef as ReactComponent };